module.exports = __webpack_public_path__ + "static/media/AI.ef91a099.svg";